var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactDetails',{attrs:{"heading":_vm.heading,"email-label":_vm.emailLabel,"phone-label":_vm.phoneLabel,"phone-label2":_vm.phoneLabel2,"newsletter-label":_vm.newsletterLabel,"empty-phone":_vm.emptyPhone,"link":_vm.link,"mypersonalinfo":_vm.myPersonalInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }